import React from 'react';
import { Folder, Handshake, TvMinimalPlay } from 'lucide-react';

export const RESUMIDO_FOLDER_ICONS: Record<string, React.ReactNode> = {
  generico: <TvMinimalPlay size={12} />,
  'mano-a-mano': <Handshake size={12} />
};

export const getResumidoFolderIcon = (sk: string): React.ReactNode => {
  return RESUMIDO_FOLDER_ICONS[sk] || <Folder size={12} />;
};
